import React, { useEffect, useState, useCallback, useMemo } from 'react';
import style from '../../Styles/Search/Search.module.css';
import MessageAlert from '../../Components/Html/MessageAlert';
import Enum from '../../Common/Enum/Enum';
import ApiCaller from '../../Api/ApiCaller';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNoteSticky,faKitchenSet,faMotorcycle,faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import { Form } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

const FormInput = ({ placeholder, value, field, optional = false, onChange, readOnly = false, searchBox = false }) => (
  <Form.Control
    as={searchBox ? "input" : "textarea"}
    type={searchBox ? "number" : "text"}
    name={field}
    placeholder={optional ? `${placeholder} (opcional)` : placeholder}
    className={`${searchBox ? style.searchInputBox : style.personalInput}`}
    value={value}
    onChange={onChange}
    readOnly={readOnly}
    translate="no"
  />
);


const InfoLabel = ({ label, value, icon }) => (
  <div className={style.infoLabel} translate="no">
    <span style={{
      fontSize: '0.75rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      color: '#6c757d',
      display: 'flex',
      alignItems: 'center',
      gap: '6px'
    }}>
      {icon && <span style={{ fontSize: '0.9rem' }}>{icon}</span>}
      {label}
    </span>
    <span style={{
      fontSize: '1rem',
      fontWeight: '500',
      color: '#212529',
      wordBreak: 'break-word'
    }}>
      {value || '—'}
    </span>
  </div>
);

const Search = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);  
  const [showField, setShowField] = useState(false);
  const [messagetext, setMessageText] = useState('');
  const [typeMessagetext, setTypeMessagetext] = useState();

  const [idOrderObj, setIdOrder] = useState({
    idOrder: '',
    phoneNumber: ''
  });
  const [formData, setFormData] = useState({
    status: '',
    firstName: '',
    lastName: '',
    adresse: '',
    orderComments: '',
    totalprice: '',
    orderDetail: []
  });

  const [apiState, setApiState] = useState({
    loading: true,
    apiData: null,
    error: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIdOrder((prev) => ({ ...prev, [name]: value }));
  };

  const updateApiState = useCallback((updates) => {
    setApiState(prev => ({ ...prev, ...updates }));
  }, []);

  const OrderDetailItem = ({ item }) => (
    <div className="order-detail-item" style={{
      display: 'flex',
      gap: '20px',
      marginBottom: '15px',
      padding: '10px',
      borderBottom: '1px solid #eee'
    }}>
      <div style={{ flex: '0 0 100px' }}>
        <img src={item.imagePath} alt={item.productDescription} style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
      </div>
      <div style={{ flex: 1 }}>
        <div><strong>{item.productDescription}</strong></div>
        <div>Cantidad: {item.quantity}</div>
        <div>Subotal: {item.linePrice}</div>
        <div style={{ fontSize: '0.9em', color: '#667' }}>{item.comments}</div>
      </div>
    </div>
  );

  useEffect(() => {
    if (apiState.apiData) {
      setFormData(prev => ({
        ...prev,
        status: apiState.apiData.status || '',
        firstName: apiState.apiData.firstName || '',
        lastName: apiState.apiData.lastName || '',
        adresse: apiState.apiData.adresse || '',
        orderComments: apiState.apiData.orderComments || '',
        totalprice: apiState.apiData.totalprice || '',
        orderDetail: apiState.apiData.orderDetail || []
      }));
      setApiState(prev => ({ ...prev, loading: false }));
    }
  }, [apiState.apiData]);

  useEffect(() => {
    if (messagetext) {
      const timer = setTimeout(() => {
        setMessageText('');
        setTypeMessagetext(undefined);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [messagetext]);

  const orderSummaryForm = useMemo(() => {
    return (
      <div className={style.mainContainer}>
        <div className={style.formContainer} >
          <InfoLabel
            label="Nombre:"
            value={`${formData.firstName} ${formData.lastName}`.trim()}
            icon="👤"
          />
          <InfoLabel
            label="Estado:"
            value={formData.status === Enum.OPEN ? "Pedida" : formData.status === Enum.INPROGRESS ? "Preparando" : formData.status === Enum.ONROUTE ? "En ruta" : "Entregada" }
            icon="📋"
          />
          <InfoLabel
            label="Forma de pago:"
            value={formData.orderComments?.replace("Forma de pago :", '')}
            icon="💬"
          />
          <InfoLabel
            label="Total:"
            value={formData.totalprice ? `Q. ${formData.totalprice}` : ''}
            icon="💰"
          />
        </div>

        <div className={style.orderDetailContainer}>
          {formData.orderDetail && formData.orderDetail.length > 0 && (
            <div>
              <h5>Detalle de la orden:</h5>
              {formData.orderDetail.map((item, index) => (
                <OrderDetailItem key={index} item={item} />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }, [formData]);

  const orderSummaryStatus = useMemo(() => {
      return(
          <div className={style.statusMainContainer}>
            <div className={style.statusContainer}>

              <div className={`${style.recibida } ${style.commonStatusStyle}`}>
                  <FontAwesomeIcon icon={faNoteSticky} className={style.icon} style={{ height: "20px" ,width : "20px" }} />
              </div>
              <div className={`${formData.status !== Enum.OPEN ? style.conectorActive : style.conector } ${style.conector1}`}>
                 <div className={`${formData.status !== Enum.OPEN ? style.hidedot : style.dot }`}></div>
                 <div className={`${formData.status !== Enum.OPEN ? style.hidedot : style.dot }`}></div>
                 <div className={`${formData.status !== Enum.OPEN ? style.hidedot : style.dot }`}></div>                  
              </div>

              <div className={`${( formData.status === Enum.INPROGRESS || formData.status === Enum.ONROUTE || formData.status === Enum.DELIVERED  )  ? style.preparandoActive : style.preparando } ${style.commonStatusStyle}`}>
                  <FontAwesomeIcon icon={faKitchenSet} className={style.icon} style={{ height: "20px" ,width : "20px" }} />
              </div>
              <div className={`${ formData.status === Enum.ONROUTE || formData.status === Enum.DELIVERED   ? style.conectorActive : style.conector} ${style.conector2}`}>
                  <div className={`${(formData.status === Enum.ONROUTE || formData.status === Enum.DELIVERED ) ?  style.hidedot  : style.dot  }`}></div>
                  <div className={`${(formData.status === Enum.ONROUTE || formData.status === Enum.DELIVERED ) ?  style.hidedot  : style.dot }`}></div>
                  <div className={`${(formData.status === Enum.ONROUTE || formData.status === Enum.DELIVERED ) ?  style.hidedot  : style.dot }`}></div>       
              </div>

              <div className={`${(formData.status === Enum.ONROUTE || formData.status === Enum.DELIVERED )? style.onRutaActive : style.enRuta }  ${style.commonStatusStyle}`}>
                  <FontAwesomeIcon icon={faMotorcycle} className={style.icon} style={{ height: "20px" ,width : "20px" }} />
              </div>              
              <div className={`${(formData.status === Enum.DELIVERED ? style.conectorActive : style.conector)} ${style.conector3}`}>
                  <div className={`${formData.status === Enum.DELIVERED ? style.hidedot : style.dot }`}></div>
                  <div className={`${formData.status === Enum.DELIVERED ? style.hidedot : style.dot }`}></div>
                  <div className={`${formData.status === Enum.DELIVERED ? style.hidedot : style.dot }`}></div>     
              </div>

              <div className={`${formData.status === Enum.DELIVERED ? style.entregada : style.icon} ${style.commonStatusStyle}`}>
                  <FontAwesomeIcon icon={faCheckCircle} className={`${style.icon}`} style={{ height: "20px" ,width : "20px"}} />
              </div>

            </div>
          </div>
      );
  },[formData])

  const searchOrder = async () => {
    setIsSubmitting(true);
    try {
      const response = await ApiCaller(process.env.REACT_APP_API_POST, process.env.REACT_APP_API_POST_GETORDERBYID, idOrderObj, {
        /*Authorization: centauri ? `Bearer ${centauri}` : ''*/
        Authorization: ''
      }
      );

      if (response && response.data.responseCode === Enum.APIRESPONSEOK) {        
        setShowField(true);
        setTimeout(() => updateApiState({ apiData: response.data }), 0);
      } else {
        setMessageText("No existe orden");
        setTypeMessagetext(2);
        setFormData({
          status: '',
          firstName: '',
          lastName: '',
          adresse: '',
          orderComments: '',
          totalprice: '',
          orderDetail: []
        });
        setShowField(false);        
        setTimeout(() => updateApiState({ apiData: undefined }), 0);
        setTimeout(() => updateApiState({ apiData: undefined }), 0);
      }
    } catch (error) {
      console.error('Error al buscar orden:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Error al buscar orden' + error;
      alert(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className={style.searchMainContainer}>

      <div className={style.searchBar}>
        <div className={style.titleSearch}>
          <p>Busca tu # de orden : </p>
        </div>
        <div className={style.barSearchInput}>
          <FormInput placeholder="No. orden" field="idOrder" onChange={handleChange} readOnly={false} searchBox />
        </div>
        <div className={style.barSearchInput}>
          <FormInput placeholder="Teléfono" field="phoneNumber" onChange={handleChange} readOnly={false} searchBox />
        </div>

        <div className={style.submitSearch}>
          <Button className={style.buttonConfirmar} onClick={() => searchOrder()} disabled={isSubmitting}>
            {isSubmitting ? 'Buscando...' : 'Buscar'}
          </Button>
        </div>
      </div>
      <div className={style.searchBox}>
        <MessageAlert text={messagetext} typeOfMessage={typeMessagetext} />
        <div>
          {showField && orderSummaryStatus}
          {showField && orderSummaryForm}
        </div>
      </div>
    </div>
  )
}

export default Search